<template>
    <Modal 
        v-model="show" 
        :mask-closable="false"
        :loading="loading" 
        @on-ok="confirmHander" 
        @on-cancel="cancelHander">
            <div slot="header" class="modal-header">{{title}}</div>   
            <Form :model="form" :label-width="100"  :rules="formRules" ref="form">
                <template v-if="type === 'add'">
                    <FormItem label="项目" prop="projectFid">
                        <Select v-model="form.projectFid" class="item-width" @on-change="changeProject" :label-in-value="true"> 
                            <Option value="">请选择</Option>
                            <Option v-for="(item,index) in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="楼栋" prop="buildingFid">
                        <Select v-model="form.buildingFid" class="item-width" @on-change="changeBuild" :label-in-value="true">
                            <Option value="">请选择</Option>
                            <Option v-for="item in list.buildList" :value="item.value" :key="item.value">{{item.text}}</Option>
                        </Select>
                    </FormItem>
                </template>
                <template v-else>
                    <FormItem label="项目">{{form.projectName}}</FormItem>
                    <FormItem label="楼栋">{{form.buildingName}}</FormItem>
                    <FormItem label="设备ID" prop="deviceId">{{form.deviceId}}</FormItem>
                </template>
                <FormItem label="设备类型" prop="deviceType">
                    <Select v-model="form.deviceType" class="item-width">
                        <Option value="">请选择</Option>
                        <Option value="0">门禁</Option>
                        <Option value="1">梯控</Option>
                    </Select>
                </FormItem>
                <FormItem label="设备名称" prop="deviceName">
                     <Input v-model="form.deviceName" class="item-width" :maxlength="30"></Input>
                </FormItem>
                <FormItem label="设备SN码" prop="deviceSn">
                   <Input v-model="form.deviceSn" class="item-width" :maxlength="13"></Input>
                </FormItem>
                <FormItem label="最高楼层" prop="highestFloor">
                    <InputNumber v-model="form.highestFloor" class="item-width" placeholder="请填写1-999" :max="999" :min="1"></InputNumber>
                </FormItem>
                <FormItem label="最低楼层" prop="lowestFloor">
                    <InputNumber v-model="form.lowestFloor" class="item-width"  placeholder="请填写-999-999" :max="999" :min="-999"></InputNumber>
                </FormItem>
            </Form>
    </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { getBuildInfo,addDevice,getDeviceInfo,updateDevice } from 'api/ladder.js';
export default {
    props: {
        value:{
            type:Boolean
        },
        title:{
            type:String,
            default:'绑定设备'
        },
        type:{
            type:String,
            default:'add'
        },
        deviceId:{
            type:Number
        }
        
    },
    data () {
        const validateHighestFloor = (rule, value, callback) => {
            if(this.checkFloor()){
                callback(new Error('总楼层不能大于92层'));
            }else{
                callback();
            }
    
        }

        const validateLowestFloor = (rule, value, callback) => {
            if(value === 0){
                callback(new Error('最低楼层不能为0'));
            }

            if(this.checkFloor()){
                callback(new Error('总楼层不能大于92层'));
            }else{
                callback();
            }
        }

        return {
            show:false,
            loading:true,
            form:{
                projectFid:'',
                projectName:'',
                deviceId:null,
                buildingFid:'',
                buildingName:'',
                deviceType:null,
                deviceName:'',
                deviceSn:'',
                highestFloor:null,
                lowestFloor:null
            },
            formRules:{
                projectFid:[
                    { required: true, message: '请选择项目' ,trigger: 'change', type:'string'}
                ],
                buildingFid:[
                    { required: true, message: '请选择楼栋' ,trigger: 'change', type:'string'}
                ],
                deviceType:[
                    { required: true, message: '请选择设备类型' ,trigger: 'blur', type:'string'}
                ],
                deviceName:[
                    { required: true, message: '请输入设备名称' ,trigger: 'blur', type:'string'}
                ],
                deviceSn:[
                    { required: true, message: '请输入设备SN码' ,trigger: 'blur', type:'string'}
                ],
                highestFloor:[
                    { required: true, message: '请输入最高楼层' ,trigger: 'change', type:'number'},
                    { trigger: 'blur',validator: validateHighestFloor}
                ],
                lowestFloor:[
                    { required: true, message: '请选择最低楼栋' ,trigger: 'change', type:'number'},
                    { trigger: 'blur',validator: validateLowestFloor}
                ],
            },
            list:{
                projectList:[],
                buildList:[]
            }     
        }
    },
    watch: {
        value(val) {
            if(val&&this.type !== 'add'){
                this.getInfo()
            }
            this.show = val
        },
        show(val){
            if(!val){
                this.initData();
            }
            this.$emit('input',val)
        } 
    },
    created () {
      this.init();  
    },
    methods: {
        confirmHander() {
             this.$refs['form'].validate(bool => {
                if(!bool){
                    this.changeLoading();
                    return;
                }
                if(this.type === 'add'){
                    this.addDeviceHander();
                }else{
                    this.updateDeviceHander();
                }
            })
        },
        cancelHander() {
            this.show = false
        },
        init() {
            getBuildInfo().then(res => {
                this.list.projectList = res.data;
            })
        },
        initData() {
            this.$refs['form'].resetFields();
            this.form.projectFid = '';
            this.form.projectName = '';
            this.form.deviceId = null;
            this.form.buildingFid = '';
            this.form.buildingName = '';
            this.form.deviceType = null;
            this.form.deviceName = '';
            this.form.deviceSn = '';
            this.form.highestFloor = null;
            this.form.lowestFloor = null;
        },
        changeProject(data) {
            this.form.buildingFid = '';
            if(data&&data.value){
                this.form.projectName = data.label;
                let _list = this.list.projectList.filter(item => item.value === data.value);
                this.list.buildList = _list[0]['children'];
            }else{
                this.list.buildList = [];
            }
            
        },
        changeBuild(data) {
            if(data){
                this.form.buildingName = data.label;
            }
        },
        changeLoading() {
            this.loading = false;
            this.$nextTick(() => {
                this.loading = true
            })
        },
        addDeviceHander() {
            addDevice(this.form).then(res => {
                console.log(res);
                this.$emit('refresh');
                this.$Message.success('绑定成功');
                this.changeLoading();
                this.show = false
            })
            .catch(error => {
                this.changeLoading();
            })
        },
        getInfo() {
            getDeviceInfo({deviceId:this.deviceId}).then(res => {
                console.log(res);
                res.data.deviceType = res.data.deviceType.toString();
                this.form = res.data;
            })
        },
        updateDeviceHander() {
            updateDevice(this.form).then(res => {
                console.log(res);
                this.$emit('refresh');
                this.$Message.success('修改成功');
                this.changeLoading();
                this.show = false
            })
            .catch(error => {
                this.changeLoading();
            })
        },
        checkFloor() {
            if(this.form.highestFloor&&this.form.lowestFloor){
                if((this.form.highestFloor-this.form.lowestFloor)>92){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        }
    }
}
</script>